<template>
  <div>
    <button @click="selectEnterpriseContact">test</button>
  </div>
</template>

<script>
export default {
	name: 'dom',
	data() {
		return {}
	},
	methods: {
		selectEnterpriseContact() {
			this.$wx.selectEnterpriseContact()
		}
	}
}
</script>

<style lang="scss" scoped>
</style>
